/**
 * Come si scrive a video il ruolo dell'utente.
 *
 * Il backend lo manda tutto minuscolo ("medico", "paziente", "operatore",
 * "amministratore"): quello e' il valore su cui il codice fa i confronti e
 * non va toccato. Qui si costruisce solo l'etichetta da mostrare, con
 * l'iniziale maiuscola e con "medico" che diventa "Specialista", che e' il
 * termine usato dall'area riservata.
 */

const ETICHETTE: { [ruolo: string]: string } = {
    medico: 'Specialista',
    paziente: 'Paziente',
    operatore: 'Operatore',
    amministratore: 'Amministratore'
};

/**
 * Restituisce la chiave di traduzione dell'etichetta. Un ruolo non previsto
 * torna con la sola iniziale maiuscola, cosi' un ruolo nuovo lato server non
 * fa comparire una stringa minuscola.
 */
export function etichettaRuolo(ruolo: string): string {
    if (!ruolo) {
        return '';
    }

    const chiave = ruolo.toLowerCase();

    return ETICHETTE[chiave] ?? chiave.charAt(0).toUpperCase() + chiave.slice(1);
}
